<template>
    <div
        ref="wrapper"
        class="info-popover-wrapper"
    >
        <button
            type="button"
            class="info-popover-trigger"
            :aria-expanded="open"
            @click.stop="toggle"
        >
            <font-awesome-icon icon="circle-question" />
        </button>
        <div
            v-if="open"
            class="info-popover-panel"
            :class="'info-popover-panel--' + placement"
            role="tooltip"
        >
            <div
                v-for="(item, index) in resolvedItems"
                :key="index"
            >
                <div
                    v-if="index > 0"
                    class="info-popover-divider"
                />
                <div class="info-popover-title">
                    {{ item.title }}
                </div>
                <div class="info-popover-content">
                    {{ item.content }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
    name: 'InfoPopover',
    components: { FontAwesomeIcon },
    props: {
        items: {
            type: Array,
            default: null
        },
        title: {
            type: String,
            default: ''
        },
        content: {
            type: String,
            default: ''
        },
        placement: {
            type: String,
            default: 'right'
        }
    },
    data() {
        return {
            open: false
        }
    },
    computed: {
        resolvedItems() {
            if (this.items && this.items.length > 0) {
                return this.items
            }
            return [{ title: this.title, content: this.content }]
        }
    },
    mounted() {
        document.addEventListener('click', this.onClickOutside)
        document.addEventListener('keydown', this.onKeyDown)
    },
    beforeUnmount() {
        document.removeEventListener('click', this.onClickOutside)
        document.removeEventListener('keydown', this.onKeyDown)
    },
    methods: {
        toggle() {
            this.open = !this.open
        },
        onClickOutside(e) {
            if (this.$refs.wrapper && !this.$refs.wrapper.contains(e.target)) {
                this.open = false
            }
        },
        onKeyDown(e) {
            if (e.key === 'Escape') {
                this.open = false
            }
        }
    }
}
</script>

<style scoped>
.info-popover-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
}

.info-popover-panel {
    position: absolute;
    z-index: 1000;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.15);
    padding: 20px 24px;
    min-width: 500px;
    max-width: 640px;
}

.info-popover-panel--right {
    top: 0;
    left: calc(100% + 8px);
}

.info-popover-panel--left {
    top: 0;
    right: calc(100% + 8px);
}

.info-popover-panel--bottom {
    top: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
}

.info-popover-panel--top {
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
}

.info-popover-title {
    color: #7FC000;
    font-size: 0.9rem;
    font-weight: 600;
    margin-bottom: 4px;
}

.info-popover-content {
    font-size: 0.82rem;
    color: #555;
    line-height: 1.4;
}

.info-popover-divider {
    border-top: 1px solid #e9ecef;
    margin: 8px 0;
}

.info-popover-trigger {
    background: transparent;
    border: none;
    color: #7FC000;
    cursor: pointer;
    padding: 2px 4px;
    font-size: 1rem;
    line-height: 1;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.info-popover-trigger:hover {
    color: #6BA800;
    background: transparent;
}
</style>
